import SvgIcon, { SvgIconProps } from '../../SvgIcon'

const GiropayIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    id="svg2226"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 885.8 380.9"
    width="2500"
    height="1075"
  >
    <g id="layer1">
      <path
        id="_92653320"
        fill="#000268"
        d="M0 68.3C0 30.6 30.8 0 68.7 0h748.5c37.9 0 68.7 30.6 68.7 68.3v244.2c0 37.7-30.7 68.3-68.7 68.3H68.7C30.8 380.9 0 350.3 0 312.6V68.3z"
      />
      <path
        id="_92186184"
        fill="#ffffff"
        d="M28.2 70.7v239.6c0 23.6 19.2 42.7 42.9 42.7h392.1V28H71.1c-23.7 0-42.9 19.1-42.9 42.7zm536.4 118.6c0 15.3-7.5 25.7-20 25.7-11 0-20.2-10.5-20.2-24.5 0-14.3 8.1-25 20.2-25 12.8.1 20 11.1 20 23.8zm-73.4 87.5h33.1v-52h.4c6.3 11.4 18.8 15.6 30.3 15.6 28.5 0 43.7-23.5 43.7-51.8 0-23.2-14.5-48.3-41-48.3-15.1 0-29 6.1-35.7 19.5h-.4v-17.3h-30.5v134.3zm152.7-69c0-9.2 8.8-12.7 20-12.7 5 0 9.7.3 14 .5 0 11.2-7.9 22.6-20.4 22.6-7.7.1-13.6-3.7-13.6-10.4zm66.8 30.4c-1.5-7.5-1.8-15.1-1.8-22.6v-35.7c0-29.2-21.1-39.7-45.6-39.7-14.1 0-26.5 2-38.2 6.8l.6 22.4c9.2-5.2 19.8-7.2 30.5-7.2 11.9 0 21.7 3.5 21.9 16.6-4.2-.7-10.1-1.3-15.4-1.3-17.6 0-49.4 3.5-49.4 32.7 0 20.8 16.9 30.1 35.8 30.1 13.6 0 22.8-5.3 30.3-17.3h.4c0 5 .5 9.9.7 15.1h30.2zm14.8 38.6c6.8 1.5 13.6 2.2 20.6 2.2 30.3 0 37.5-23.4 46.9-47.4l35.1-89.1H795L775.3 205h-.3l-20.6-62.5h-35.6l38.8 98c-2.4 8.5-8.6 13.2-16.7 13.2-4.6 0-8.6-.6-13.1-2l-2.3 25.1z"
      />
      <path
        id="_47303032"
        fill="#ff0007"
        d="M109 189.5c0-13.1 6.4-23.9 18.8-23.9 14.9 0 21.1 11.9 21.1 22.6 0 14.7-9.4 24.6-21.1 24.6-10 0-18.8-8.4-18.8-23.3zm71.9-47.1h-30v17.3h-.3c-7-11.8-18.4-19.5-32.5-19.5-29.8 0-43.2 21.3-43.2 49.8 0 28.3 16.4 48.2 42.6 48.2 13.3 0 24.3-5.2 32.2-16.4h.4v5.2c0 18.7-10.3 27.7-29.4 27.7-13.8 0-22.3-2.9-32.4-7.9l-1.7 26.1c7.7 2.8 20.8 6.1 36.6 6.1 38.6 0 57.7-12.7 57.7-52v-84.6zm55.9-39.9h-33.1v24.3h33.1v-24.3zm-33.1 135.7h33.1v-95.8h-33.1v95.8zm125.2-96.9c-3.3-.5-7.4-1.1-11.2-1.1-14.3 0-22.6 7.7-28.3 19.9h-.4v-17.6h-30.1v95.8H292v-40.4c0-18.8 8.7-30 24.1-30 3.9 0 7.5 0 11.2 1.1l1.6-27.7zm57 75.9c-15.3 0-21.5-12.7-21.5-26.8 0-14.3 6.2-27 21.5-27s21.5 12.7 21.5 27c0 14.1-6.3 26.8-21.5 26.8zm0 23.2c31.6 0 55.7-18.4 55.7-50 0-31.8-24.1-50.2-55.7-50.2s-55.7 18.4-55.7 50.2c0 31.6 24 50 55.7 50z"
      />
    </g>
  </SvgIcon>
)

export default GiropayIcon
